import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CampanasInx from "../components/Campana/CampanasInx.jsx";
import CompClientes from "../components/Clientes/CompClientes.jsx";
import TicketsSinEvento from "../components/Clientes/TicketsSinEvento/TicketsSinEvento.jsx";
import HistorialEjecuciones from "../components/Campana/HistorialEjecuciones.jsx";
import clsx from "clsx";
import { Button } from "@headlessui/react";

import infVerd from "../assets/campanas/icono info verde.svg";
import { Tooltip } from "../components/ui/Tooltip.jsx";
import ModalInfoCampanas from "../components/Modales/infoCam.jsx";
import ticketsService from "../services/ticketsService";

export default function Campanas() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [modulo, setModulo] = useState(() => {
    const mod = searchParams.get("modulo") || searchParams.get("tab");
    if (mod === "tickets-sin-evento" || mod === "sin-evento") return "tickets-sin-evento";
    if (mod === "tickets") return "tickets";
    if (mod === "historial") return "historial";
    // Si viene ticketId sin eventId, asumir tickets-sin-evento
    if (searchParams.get("ticketId") && !searchParams.get("eventId")) return "tickets-sin-evento";
    return "campana";
  });
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [conteoSinEvento, setConteoSinEvento] = useState(0);

  // Sincronizar query params si cambian
  useEffect(() => {
    const mod = searchParams.get("modulo") || searchParams.get("tab");
    if (mod === "tickets-sin-evento" || mod === "sin-evento") {
      setModulo("tickets-sin-evento");
    } else if (mod === "tickets") {
      setModulo("tickets");
    } else if (mod === "historial") {
      setModulo("historial");
    } else if (searchParams.get("ticketId") && !searchParams.get("eventId")) {
      setModulo("tickets-sin-evento");
    }
  }, [searchParams]);

  // Cargar contador de tickets sin evento abiertos
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await ticketsService.getAllTickets({ sin_evento: true, estatus: "abierto" });
        if (res.success && Array.isArray(res.tickets)) {
          setConteoSinEvento(res.tickets.length);
        }
      } catch (err) {
        console.error("Error al obtener conteo sin evento:", err);
      }
    };
    fetchCount();
  }, []);

  const handleCambiarModulo = (nuevoModulo) => {
    setModulo(nuevoModulo);
    // Limpiar searchParams para evitar conflictos de navegación
    const newParams = new URLSearchParams(searchParams);
    newParams.set("modulo", nuevoModulo);
    setSearchParams(newParams, { replace: true });
  };

  return (
    <div className="p-3 md:p-6 bg-white dark:bg-fodoBlack rounded-3xl shadow-md h-full">
      <ModalInfoCampanas open={showInfoModal} onClose={() => setShowInfoModal(false)} />
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        {modulo === "campana" ? (
          <div>
            <h1 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">
              Módulo de Automatizaciones
            </h1>
            <div className="flex gap-2">
              <p className="text-gray-500 dark:text-gray-200">
                Crea flujos automáticos basados en eventos de estudiantes y pagos.
              </p>
               <Button onClick={() => setShowInfoModal(true)}>
                <Tooltip content="Más información sobre automatizaciones">
                  <img
                    src={infVerd}
                    alt="Información"
                    className="h-6 w-6 mt-1"
                  />
                </Tooltip>
              </Button>
            </div>
          </div>
        ) : modulo === "tickets" ? (
          <div className="md:w-9/12">
            <h1 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">
              Módulo de Clientes
            </h1>
            <p className="text-gray-500 dark:text-gray-200 line-clamp-5 sm:line-clamp-5 md:line-clamp-3">
              Gestiona solicitudes personalizadas de los asistentes. Cada
              solicitud genera un ticket que es atendido por un asesor humano,
              ideal para casos como cambios de boletos, actualizaciones de
              información o aclaraciones de pago.
            </p>
          </div>
        ) : modulo === "tickets-sin-evento" ? (
          <div className="md:w-9/12">
            <h1 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">
              Tickets sin Evento
            </h1>
            <p className="text-gray-500 dark:text-gray-200 line-clamp-5 sm:line-clamp-5 md:line-clamp-3">
              Atiende solicitudes de personas o números de WhatsApp no vinculados a ningún evento registrado.
              Responde sus dudas directamente por chat o gestiona su estado.
            </p>
          </div>
        ) : (
          <div>
            <h1 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">
              Historial de Ejecuciones
            </h1>
            <p className="text-gray-500 dark:text-gray-200">
              Revisa el historial completo de ejecuciones, estadísticas y métricas de tus automatizaciones.
            </p>
          </div>
        )}

        <div className="sm:max-w-xl flex justify-center md:justify-end mt-4 md:mt-0 gap-2 flex-wrap">
          <Button
            onClick={() => handleCambiarModulo("campana")}
            className={clsx(
              "rounded-full px-3 py-1 text-sm/6 font-semibold focus:outline-none transition",
              modulo === "campana"
                ? "bg-casal text-white shadow dark:bg-casal"
                : "hover:bg-white/15 text-grey dark:text-gray-600 bg-porcelain"
            )}
          >
            Automatizaciones
          </Button>
          <Button
            onClick={() => handleCambiarModulo("tickets")}
            className={clsx(
              "rounded-full px-3 py-1 text-sm/6 font-semibold focus:outline-none transition",
              modulo === "tickets"
                ? "bg-casal text-white shadow dark:bg-casal"
                : "hover:bg-white/15 text-grey dark:text-gray-600 bg-porcelain"
            )}
          >
            Monitor de ticket
          </Button>
          <Button
            onClick={() => handleCambiarModulo("tickets-sin-evento")}
            className={clsx(
              "rounded-full px-3 py-1 text-sm/6 font-semibold focus:outline-none transition flex items-center gap-1.5",
              modulo === "tickets-sin-evento"
                ? "bg-casal text-white shadow dark:bg-casal"
                : "hover:bg-white/15 text-grey dark:text-gray-600 bg-porcelain"
            )}
          >
            <span>Tickets sin Evento</span>
            {conteoSinEvento > 0 && (
              <span
                className={clsx(
                  "px-1.5 py-0.2 text-[11px] font-bold rounded-full",
                  modulo === "tickets-sin-evento"
                    ? "bg-white text-casal"
                    : "bg-red-500 text-white"
                )}
              >
                {conteoSinEvento}
              </span>
            )}
          </Button>
          <Button
            onClick={() => handleCambiarModulo("historial")}
            className={clsx(
              "rounded-full px-3 py-1 text-sm/6 font-semibold focus:outline-none transition",
              modulo === "historial"
                ? "bg-casal text-white shadow dark:bg-casal"
                : "hover:bg-white/15 text-grey dark:text-gray-600 bg-porcelain"
            )}
          >
            Historial
          </Button>
        </div>
      </div>
      <div className="mt-3 w-full overflow-hidden">
        {modulo === "campana" && <CampanasInx />}
        {modulo === "tickets" && <CompClientes />}
        {modulo === "tickets-sin-evento" && (
          <TicketsSinEvento initialTicketId={searchParams.get("ticketId")} />
        )}
        {modulo === "historial" && <HistorialEjecuciones />}
      </div>
    </div>
  );
}
